
  import {Component, Prop, Vue} from "vue-property-decorator";

  @Component({
    name: 'TableHeader'
  })
  export default class extends Vue {
    @Prop() private vo!: ButtonListVo;
    @Prop() private sendCountVo!: sendCountVo;

    private modifyClick(): void {
      this.$emit('modifyClick');
    }

    private saveClick(): void {
      obj_ScanForOutbound_GetOff.saveClick();
      this.$emit('saveClick');
    }

    private delClick(): void {
      this.$emit('delClick');
    }

    private submitClick(): void {
      this.$emit('submitClick');
    }
  }
